import cn from 'classnames';
import Image from 'next/image';
import Heading from '@components/ui/Heading';

export enum MerchBoxSize {
  Small = 'small',
  Large = 'large',
}

export interface MerchBoxProps {
  title: string;
  url: string;
  image: {
    url: string;
    alt: string;
  };
  merchBoxSize: MerchBoxSize;
  hasPlpBanner?: boolean;
}

const plpMerchBoxLargeBox = 'plpMerchBoxLargeBox';
const plpMerchBoxSmallBox = 'plpMerchBoxSmallBox';
const plpMerchBoxTextBox = 'plpMerchBoxTextBox';

const MerchBox = ({
  title,
  image,
  url,
  merchBoxSize,
  hasPlpBanner,
}: MerchBoxProps) => {
  if (!title && !url) return null;

  const plpMerchBoxHasImage = image && image?.url;
  const headerStyleLevel = plpMerchBoxHasImage ? '6' : '3';

  return (
    <div
      className={cn('plpMerchBox', {
        [plpMerchBoxLargeBox]: merchBoxSize === MerchBoxSize.Large,
        [plpMerchBoxSmallBox]: merchBoxSize === MerchBoxSize.Small,
        [plpMerchBoxTextBox]: !plpMerchBoxHasImage,
      })}
    >
      <a href={url} role="link" className="plpMerchBoxInnerContainer">
        {plpMerchBoxHasImage ? (
          <div className="plpMerchBoxImageContainer">
            <Image
              priority={hasPlpBanner ? false : true}
              src={image?.url}
              alt={image?.alt}
              width={250}
              height={100}
              sizes="(min-width: 720px) 250px, (min-width: 480px) 325px, 194px"
              style={{
                width: '100%',
                height: 'auto',
              }}
            />
          </div>
        ) : null}
        <Heading
          semanticLevel="span"
          styleLevel={headerStyleLevel}
          className="plpMerchBoxHeading"
        >
          {title}
        </Heading>
      </a>
    </div>
  );
};

export default MerchBox;
